<template>
  <v-container fluid style="margin: 15px; padding: 15px; width: 100%">
    <v-overlay :value="loading">
      <v-progress-circular
          :size="150"
          indeterminate
          style="text-align: center"
      >
        Loading Data
      </v-progress-circular>
    </v-overlay>

    <!-- Search -->
    <v-row>
      <v-col>
        <v-text-field
            placeholder="Search Last Name"
            v-model="searchData.last_name"
            label="Search Last Name"
            v-on:keydown.enter="onSearch"
        />
      </v-col>
      <v-col>
        <v-text-field
            placeholder="Search Claim ID"
            v-model="searchData.claim_id"
            label="Search Claim ID"
            v-on:keydown.enter="onSearch"
        />
      </v-col>
      <v-col>
        <v-btn color="success" class="mr-4" @click="onSearch">Search</v-btn>
        <v-btn class="mr-4" @click="resetSearch">RESET</v-btn>
      </v-col>
    </v-row>

    <v-card class="mx-auto">
      <v-card-title>
        List of CF4 Records
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
          <tr>
            <th class="text-left">Patient ID</th>
            <th class="text-left">E-Claims Transmittal ID</th>
            <th class="text-left">Claim ID No</th>
            <th class="text-left">PIN</th>
            <th class="text-left">Last Name</th>
            <th class="text-left">First Name</th>
            <th class="text-left">Middle Name</th>
            <th class="text-left">Suffix</th>
            <th class="text-left">Recorded Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in data.data" :key="i">
            <td>{{ item.id }}</td>
            <td>{{ item.transmittal_id }}</td>
            <td>{{ item.claim_id }}</td>
            <td>{{ item.patient_pin }}</td>
            <td>{{ item.last_name }}</td>
            <td>{{ item.first_name }}</td>
            <td>{{ item.middle_name }}</td>
            <td>{{ item.suffix }}</td>
            <td>{{ item.created_at }}</td>

            <td>
              <v-btn @click="" color="info" fab x-small dark :to="'/edit/'+item.id+''">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn @click="generateXml(item.id)" color="secondary" fab x-small dark>
                <v-icon>mdi-xml</v-icon>
              </v-btn>
              <v-menu open-on-hover offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="secondary"
                    fab
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-document-outline</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item @click="openReport('CF3', item.id)">
                    <v-list-item-title>CF3 PDF</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openReport('CF4', item.id)">
                    <v-list-item-title>CF4 PDF</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
        <v-pagination
            v-model="page"
            :circle="circle"
            :length="length"
            :next-icon="nextIcon"
            :prev-icon="prevIcon"
            :page="page"
            :total-visible="totalVisible"
        />
      </v-card-text>

      <v-dialog v-model="dialog" persistent>

        <v-card>
          <v-card-title>
            <span class="headline">CF4 XML VIEWER</span>
          </v-card-title>
          <v-card-text>
            <v-container class="codemirror">
              <codemirror ref="myCm"
                          :value="code"
                          :options="cmOptions"
                          @ready="onCmReady"
                          @focus="onCmFocus"
                          @input="onCmCodeChange">
              </codemirror>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="downloadXml(cf4.patientId)">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

import 'vue-progress-path/dist/vue-progress-path.css'

import 'codemirror/theme/gruvbox-dark.css';
import 'codemirror/mode/xml/xml';
import 'vue-progress-path/dist/vue-progress-path.css';


export default {
  name: "CF4ListPage",


  data() {
    return {
      circle: true,
      length: 2,
      per_page: 0,
      nextIcon: 'navigate_next',
      prevIcon: 'navigate_before',
      page: 1,
      totalVisible: 10,
      total: 0,
      data: [],
      id: '',
      active: 'xml',
      hideBackground: true,
      progress: false,
      dialog: false,
      indeterminate: false,
      code: '',
      cmOptions: {
        // codemirror options
        theme: 'gruvbox-dark',
        mode: 'text/xml',
        tabSize: 4,
        indentWithTabs: true,
        lineWrapping: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      searchData: {
        last_name: '',
        claim_id: '',
        searching: false,
      },
      loading: false,
      pdfDialog: false,
      pdfUrl: '',
      pdfTitle: ''
    }
  },
  watch: {
    page: function () {
      this.loadList();
    }
  },
  methods: {
    async loadList() {
      this.loading = true;
      let url = this.page !== 0 ? `list?page=${this.page}` : 'list';
      await this.axios.get(url, {
        params: this.searchData,
        headers: {
          'Authorization': `Bearer ` + localStorage.getItem('AUTH_TOKEN'),
        }
      }).then((response) => {
        const {data} = response.data;
        const {current_page, last_page, per_page, total} = data;
        if (data.length !== 0) {
          this.page = current_page;
          this.length = last_page;
          this.per_page = per_page;
          this.data = data;
          this.total = total;
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        // always executed
        this.loading = false;
      });
    },

    reset() {
      this.page = 0;
      this.length = 0;
      this.per_page = 0;
      this.total = 0;
      this.data = [];
    },

    onSearch() {
      this.searchData.searching = true;
      this.reset();
      this.loadList();
    },

    resetSearch() {
      this.searchData.searching = false;
      this.searchData.last_name = '';
      this.searchData.claim_id = '';
      this.loadList();
    },

    openReport(type, pid) {
      let url = this.axios.defaults.baseURL;
      let route = '';

      if (type === 'CF3') {
        route = '/pdfCF3';
      } else if (type === 'CF4') {
        route = '/pdfCF4';
      }

      window.open(
        `${url}${route}?id=${pid}`,
        'pdfWindow',
        'width=900,height=700,resizable=yes,scrollbars=yes,status=1'
      );
    },

    generateXml(id) {
      this.progress = true;
      this.indeterminate = true;
      this.id = id;
      this.$store.dispatch("setPid", id);

      this.axios.post('xmlize', {'id': id}, {
        headers: {
          'Authorization': `Bearer ` + localStorage.getItem('AUTH_TOKEN'),
        }
      }).then((response) => {
        this.dialog = true;
        this.code = response.data.data;
        this.progress = false;
        this.hideBackground = true;
        this.indeterminate = false;
      }).catch((error) => {

      }).finally(() => {
        // always executed
      });
    },


    downloadXml(id) {
      this.axios.post('download', {'id': id},
          {
            headers: {
              'Authorization': `Bearer ` + localStorage.getItem('AUTH_TOKEN'),
            }
          }).then((response) => {
        window.open(response.data.url, '_blank');
      }).catch((error) => {

      }).finally(() => {
        // always executed
      });
    },

    onCmReady(cm) {

      console.log('the editor is readied!', cm);
    },
    onCmFocus(cm) {
      console.log('the editor is focus!', cm);
    },
    onCmCodeChange(newCode) {
      // console.log('this is new code', newCode);
      this.code = newCode
    }
  },
  computed: {
    codemirror() {
      return this.$refs.myCm.codemirror
    },
    ...mapState({
      cf4: state => state.cf4
    })
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style scoped>
.container.codemirror {
  max-width: 100%;
  min-height: 80%;
}

[role=presentation] {
  margin: 10px;
}
</style>
